<template>
  <v-dialog v-model="dialog" max-width="290px" transition="dialog-transition" data-testid="time__dialog">
    <template v-slot:activator="{ attrs, on }">
      <v-text-field
        ref="element"
        dense
        outlined
        :label="label || 'Time'"
        clearable
        v-bind="attrs"
        v-on="on"
        :error-messages="error"
        :value="formattedRangevalue"
        :hide-details="hidedetails"
        :disabled="disabled"
        @click:clear="setBlank(); updateValue()"
        data-testid="time__textfield"
      ></v-text-field>
    </template>

    <v-card elevation="0" flat tile data-testid="time__card">
      <v-card-text class="pa-0" data-testid="time__card-text">
        <v-time-picker v-model="tempContent" color="primary" scrollable data-testid="time__picker">
          <v-spacer data-testid="time__spacer"></v-spacer>
          <v-btn text @click="dialog = false; tempContent = content; updateValue()" data-testid="time__close-btn"><span data-testid="time__close-label">Close</span></v-btn>
          <v-btn elevation="0" color="primary" @click="content = tempContent; dialog = false; updateValue()" data-testid="time__ok-btn"><span data-testid="time__ok-label">OK</span></v-btn>
        </v-time-picker>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    dialog: false,
    content: "",
    tempContent: ""
  }),
  props: {
    error: [String, Array],
    label: String,
    value: String,
    hidedetails: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  methods: {
    setValue() {
      this.content = this.value || "";
    },
    updateValue() {
      this.content = this.tempContent;  // Ensure content updates correctly
      this.$emit("input", this.content);
      this.$emit("change", this.content);
    },
    setFocus() {
      this.$nextTick(() => {
        this.$refs.element?.$el.querySelector("input")?.focus();
      });
    },
    setBlank() {
      this.content = "";
      this.tempContent = "";
    }
  },
  computed: {
    formattedRangevalue() {
      return this.content ? this.$nova.formatTime(this.content) : "";
    }
  },
  watch: {
    value(newVal) {
      this.setValue();
      if (!newVal) this.setBlank();
    }
  },
  created() {
    this.setValue();
  }
};
</script>
